import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as modal from '../../reducers/modalReducer';
import * as addressReducer from '../../reducers/addressReducer';
import {getLocalProps} from '../../helpers/localStorage';
import MaintenancePage from '../Maintenance';
import {
  isAgeGateSelector,
  isStartShoppingPopUp,
  isUnidentifiedCustomer as isUnidentifiedCustomerSelector,
  isKioskWithPurchasing as isKioskWithPurchasingSelector,
  isSalesChannelNameProvided,
  isRootSalesChannelEnabled,
} from '../../selectors/configSelectors';
import {
  isKioskMode as isKioskSelector
} from '../../selectors/viewSelectors';
import * as QueryParams from '../../const/query_params';

import {getValidTokenKiosk} from "../../services/getValidToken";
import {useKioskCustomer} from "../../actions/login";
import { isAgeConfirmed } from '../../selectors/customer_selectors';
import SalesChannelNotification from '../SalesChannelNotification/sales_channel_notification';
import { getQueryParameter } from '../../services/uri';

class Config extends Component {
  state = {
    isFetched: false,
  };

  shouldComponentUpdate(nextProps) {
    return (
      this.state.isFetched !== nextProps.config.configFetched ||
      this.props.maintenance !== nextProps.maintenance
    );
  }

  componentDidUpdate() {
    this.init();
  }
  
  init = () => {
    const { isUnidentifiedCustomer, isKioskMode, isKioskWithPurchasing, isKioskModeEnabled } = this.props;
    const p = getLocalProps();
    if (!p || !p.hasOwnProperty('isAddrssBarOpened') || p.isAddrssBarOpened) {
      this.props.showAddressBar();
    }

    if (isKioskMode && isKioskWithPurchasing) {
      if (!isKioskModeEnabled) {
        this.props.kioskDisabledForm();
        return;
      }

      getValidTokenKiosk();
      
      if (!this.props.token) {
        if (!this.props.kioskToken) {
          this.props.showKioskLoginForm();
          return;
        }
      }
    }

    if (window.location.search.indexOf(QueryParams.RESET_PASSWORD_RETRIEVE_TOKEN) > -1) {
      this.props.openVerifyResetPasswordModal(getQueryParameter(QueryParams.RESET_PASSWORD_RETRIEVE_TOKEN));
    }

    if (this.props.isAgeGate && !this.props.isAgeConfirmed) {
      this.props.openAgeConfirmForm();
    }

    if (isUnidentifiedCustomer) {
      this.props.useKioskCustomer();
    }
  };

  isCheckSalesChannelStateRequired = () => {
    return this.props.isAgeConfirmed && this.props.isSalesChannel;
  }

  render() {
    const {
      children,
      config,
      maintenance,
    } = this.props;

    const { configFetched } = config;

    if (maintenance) return <MaintenancePage />;

    return (
      <div>
        {configFetched && <div>{children}</div>}
        {configFetched
          && this.isCheckSalesChannelStateRequired()
          && <SalesChannelNotification />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  const isKioskModeEnabled = false;
  return {
    config: state.config,
    token: state.user.tokens.token,
    kioskToken: state.kioskUser.tokens.token,
    maintenance: state.config.maintenance,
    isKioskMode: isKioskSelector(state),
    isKioskWithPurchasing: isKioskWithPurchasingSelector(state),
    isAgeGate: isAgeGateSelector(state),
    isKioskModeEnabled,
    isStartShopping: isStartShoppingPopUp(state),
    isUnidentifiedCustomer: isUnidentifiedCustomerSelector(state),
    isAgeConfirmed: isAgeConfirmed(state),
    isSalesChannel: isRootSalesChannelEnabled(state.config) || isSalesChannelNameProvided(state),
  };
};

const mapDispatchToProps = dispatch => ({
  showAddressBar: () => dispatch(addressReducer.showAddressBar()),
  openAgeConfirmForm: () => dispatch(
    modal.openModal({
      modalType: 'AGE_CONFIRM_FORM',
      modalProps: {}
    })
  ),
  openVerifyResetPasswordModal: (retrieveToken) => dispatch(
    modal.openModal({
      modalType: 'PASSWORD_FORM',
      modalProps: {
        type: 'PASSWORD_RESET',
        retrieveToken
      }
    })
  ),
  kioskDisabledForm: () => dispatch(modal.openModal({
    modalType: 'KIOSK_DISABLED_FORM',
    modalProps: {}
  })),
  showKioskLoginForm: (onClose) => dispatch(modal.openModal({
    modalType: 'KIOSK_LOGIN_FORM',
    modalProps: {unclosable: true, onClose}
  })),
  useKioskCustomer: () => {
    dispatch(useKioskCustomer());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Config);



// WEBPACK FOOTER //
// ./src/components/Config/Config.jsx